<template>
  <v-container class="chat-container">
    <div class="chat-box-label">
      <h3>🔵 Chat Box</h3>
    </div>

    <!-- Scrollable Chat Box -->
    <div class="chat-box">
      <v-list class="main-msg-container">
        <v-list-item
          v-for="(msg, index) in messages"
          :key="index"
          class="message-container"
          :class="{ 'own-message': msg.username === myUsername }"
        >
          <v-list-item-content class="message-content">
            <v-list-item-title class="message-text">
              <strong class="username">{{ msg.username }}</strong>
              <span>{{ msg.text }}</span>
            </v-list-item-title>
            <v-list-item-subtitle class="timestamp">{{ msg.timestamp }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>

    <div class="input-container">
      <v-text-field
        v-model="newMessage"
        label="Type a message..."
        clearable
        outlined
        dense
         background-color="white"
        class="message-input"
        @keyup.enter="sendMessage"
      ></v-text-field>
      <v-btn @click="sendMessage" color="primary" class="send-btn">Send</v-btn>
      <!-- dev clear all -->
      <!-- <v-btn @click="clearChat" color="error" class="clear-btn">Clear</v-btn> -->
    </div>
  </v-container>
</template>

<script>
import Gun from "gun";

export default {
  name: "ChatBox",
  data() {
    return {
      gun: null,
      chat: null,
      newMessage: "",
      messages: [],
      messageKeys: new Set(),
      myUsername: "User" + Math.floor(Math.random() * 100),
    };
  },
  mounted() {
    this.gun = Gun(["https://gun-manhattan.herokuapp.com/gun"]);
    this.chat = this.gun.get("global-chat");

    this.chat.map().on((data, key) => {
      if (data && !this.messageKeys.has(key)) {
        this.messageKeys.add(key);
        this.messages.push({
          username: data.username || "Anonymous",
          text: data.text,
          timestamp: new Date(data.timestamp).toLocaleTimeString(),
        });

        this.scrollToBottom();
      }
    });
  },
  methods: {
    sendMessage() {
      if (this.newMessage.trim() !== "") {
        this.chat.set({
          username: this.myUsername,
          text: this.newMessage,
          timestamp: Date.now(),
        });
        this.newMessage = "";
      }
    },
    clearChat() {
      this.chat.map().once((data, key) => {
        this.chat.get(key).put(null);
      });
      this.messages = [];
      this.messageKeys.clear();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatBox = this.$el.querySelector(".chat-box");
        if (chatBox) chatBox.scrollTop = chatBox.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.chat-container {
  max-width: 500px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* Scrollable Chat Box */
.chat-box {
  width: 100%;
  max-height: 350px;
  min-height: 350px;
  overflow-y: auto;
  border-radius: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

/* Message Styling */
.message-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  padding: 5px;
}

.own-message {
  justify-content: flex-end;
}

.message-content {
  max-width: 80%;
  padding: 8px 12px;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.own-message .message-content {
  background-color: #44698e;
  color: white;
}

/* Message Bubble */
.message-text {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.username {
  font-weight: bold;
  color: #3b5998;
}

/* Timestamp Styling */
.timestamp {
  font-size: 12px;
  color: gray;
  margin-top: 4px;
  text-align: right;
}

/* Input and Button Styling */
.input-container {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.message-input {
  flex: 1;
}

.send-btn {
  margin-left: 10px;
}

.clear-btn {
  margin-left: 5px;
}

.chat-box-label {
  color: white;
}
</style>
